import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormGroupDirective } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatSidenavModule } from '@angular/material/sidenav';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { OrderListEffects } from '@app/order-list/store/order-list.effects';
import { ProductsModule } from '@products/products.module';
import { ImageCarouselModule } from '@shared/components/image-carousel/image-carousel.module';
import { SharedModule } from '@shared/shared.module';
import { ProductSortimentFeature } from '@sortiment/store/product-sortiment.slice';

import { ProductSortimentEffects } from './../sortiment/store/product-sortiment.effects';
import { SearchCategorySelectOldComponent } from './components/search-category-select-old/search-category-select-old.component';
import { SearchCategorySelectComponent } from './components/search-category-select/search-category-select.component';
import { SearchInputComponent } from './components/search-input/search-input.component';
import { SearchProductModalComponent } from './components/search-product-modal/search-product-modal.component';
import { SearchResultCardComponent } from './components/search-result-card/search-result-card.component';
import { CheckboxSubformComponent } from './components/sub-components/checkbox-subform/checkbox-subform.component';
import { PriceSearchSubformComponent } from './components/sub-components/price-search-subform/price-search-subform.component';
import { SelectorSubformComponent } from './components/sub-components/selector-subform/selector-subform.component';
import { TextInputSubformComponent } from './components/sub-components/text-input-subform/text-input-subform.component';
import { ProductDetailsContainerComponent } from './containers/product-details-container/product-details-container.component';
import { ResultsContainerComponent } from './containers/results-container/results-container.component';
import { SearchContainerComponent } from './containers/search-container/search-container.component';
import { SearchRoutingModule } from './search-routing.module';
import { ProductSearchEffects } from './store/search.effects';
import { ProductSearchFeature } from './store/search.slice';

@NgModule({
  declarations: [
    SearchContainerComponent,
    SearchResultCardComponent,
    PriceSearchSubformComponent,
    SearchInputComponent,
    SearchCategorySelectComponent,
    SearchCategorySelectOldComponent,
    ResultsContainerComponent,
    TextInputSubformComponent,
    SelectorSubformComponent,
    CheckboxSubformComponent,
    SearchProductModalComponent,
    ProductDetailsContainerComponent,
  ],
  imports: [
    CommonModule,
    SearchRoutingModule,
    MatSidenavModule,
    MatFormFieldModule,
    MatInputModule,
    MatExpansionModule,
    SharedModule,
    ProductsModule,
    ImageCarouselModule,
    StoreModule.forFeature(ProductSearchFeature),
    StoreModule.forFeature(ProductSortimentFeature),
    EffectsModule.forFeature([
      ProductSearchEffects,
      OrderListEffects,
      ProductSortimentEffects,
    ]),
  ],
  exports: [SearchInputComponent],
  providers: [FormGroupDirective],
})
export class SearchModule {}
